module.exports = ".h3-workflow {\n  margin-bottom: 1.5rem !important;\n  text-align: center;\n  font-size: 1.45rem; }\n\n@media (max-width: 770px) {\n  .h3-workflow {\n    font-size: 1em;\n    margin-bottom: 0.8rem !important; } }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/component/step-parcours-lbpa/step-signature-parcours-lbpa.component.scss
// module id = VahR
// module chunks = 1